import { Currency } from '@/core/currency/interfaces';

const SDG: Currency = {
    name: 'Sudanese Pound',
    demonym: 'Sudanese',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '938',
    symbol: '£SD',
    symbolNative: 'ج.س.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SDG',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SDG;
